import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useTenant } from '../../context/TenantContext';
import api from '../../utils/api';
import { toast } from 'sonner';

const ChatInbox = () => {
  const { activeTenant, tenants } = useTenant();
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');

  const activeTenantLabel = tenants.find((tenant) => tenant.id === activeTenant)?.name || activeTenant;

  const loadMessages = async () => {
    if (!activeTenant) return;
    try {
      const res = await api.get(`/chat/messages?tenant_id=${activeTenant}`);
      setMessages(res.data || []);
    } catch (error) {
      toast.error('Error al cargar mensajes');
    }
  };

  useEffect(() => {
    loadMessages();
  }, [activeTenant]);

  const handleSend = async (event) => {
    event.preventDefault();
    if (!message.trim() || !activeTenant) return;
    try {
      await api.post('/chat/messages', { tenant_id: activeTenant, message: message.trim() });
      setMessage('');
      loadMessages();
    } catch (error) {
      toast.error('Error al enviar mensaje');
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="operator-chat-page">
      <div>
        <h1 className="text-4xl font-heading font-bold">Bandeja de chat</h1>
        <p className="text-muted-foreground">
          Conversaciones por tenant. Activo: {activeTenantLabel || 'sin seleccionar'}
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Mensajes</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {!activeTenant && (
            <p className="text-sm text-muted-foreground">Selecciona un tenant para ver mensajes.</p>
          )}
          {activeTenant && (
            <>
              <div className="max-h-[420px] overflow-y-auto space-y-3 border rounded-lg p-4">
                {messages.length === 0 ? (
                  <p className="text-sm text-muted-foreground">No hay mensajes todavia.</p>
                ) : (
                  messages.map((msg) => (
                    <div key={msg.id} className="space-y-1">
                      <div className="text-xs text-muted-foreground">
                        {msg.sender_name} · {msg.sender_role} · {msg.created_at?.split('T')[0]}
                      </div>
                      <div className="rounded-lg bg-muted px-3 py-2 text-sm">{msg.message}</div>
                    </div>
                  ))
                )}
              </div>
              <form onSubmit={handleSend} className="flex gap-2">
                <Input
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  placeholder="Escribe tu mensaje..."
                />
                <Button type="submit">Enviar</Button>
              </form>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ChatInbox;
